import { WithChakraUI } from '@barbershop/providers/chakra-ui'
import { WithDayjs } from '@barbershop/providers/dayjs'
import { WithTanstackQuery } from '@barbershop/providers/tanstack-query'
import { WithToast } from '@barbershop/providers/toast'

import { WithTanstackRouter } from './tanstack-router'

export const WithProviders = () => {
    return (
        <WithDayjs>
            <WithChakraUI>
                <WithTanstackQuery>
                    <WithTanstackRouter />
                    <WithToast />
                </WithTanstackQuery>
            </WithChakraUI>
        </WithDayjs>
    )
}
